<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show.sync="show"
  >
<!--    <CSidebarBrand-->
<!--      :imgFull="{ width: 118, height: 46, alt: 'Logo', src: 'img/brand/sf-logo.svg'}"-->
<!--      :imgMinimized="{ width: 118, height: 46, alt: 'Logo', src: 'img/brand/sf-logo-mini.svg'}"-->
<!--      :wrappedInLink="{ href: '/'}"-->
<!--    />-->
    <CSidebarBrand class="d-md-down-none" to="/">
        <img class="c-sidebar-brand-full" width="118" height="46" alt="Logo" src="img/brand/sf-logo.svg">
        <img class="c-sidebar-brand-minimized" width="118" height="46" alt="Logo" src="img/brand/sf-logo-mini.svg">
<!--      <CIcon-->
<!--          class="c-sidebar-brand-full"-->
<!--          name="logo"-->
<!--          size="custom-size"-->
<!--          :height="35"-->
<!--          viewBox="0 0 556 134"-->
<!--      />-->
<!--      <CIcon-->
<!--          class="c-sidebar-brand-minimized"-->
<!--          name="logo"-->
<!--          size="custom-size"-->
<!--          :height="35"-->
<!--          viewBox="0 0 110 134"-->
<!--      />-->
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>
import { flatten } from 'lodash';
import {nav, navDashboard, navNotifications, navOrders, navEstimates, navLibrary, navTools} from './_nav'
import admin_nav from './_admin_nav'
import DocumentFolder from "../models/DocumentFolder";

export default {
  name: 'TheSidebar',
  data () {
    return {
      minimize: false,
      nav: [],
      show: 'responsive'
    }
  },
  methods: {
    fetchDocumentFolders(nextPageUrl = null) {
      let temp = JSON.parse(JSON.stringify(navLibrary));
      let params = { parent_folder_id: null, private: 0, url: nextPageUrl };
      return DocumentFolder.api().fetch(params).then((documentFoldersResponse) => {
        let folders = DocumentFolder.query().where('parent_folder_id', null).where('private', 0).get();

        folders.forEach((folder) => {
          temp.push({
            _name: 'CSidebarNavItem',
            name: folder.name,
            to: '/documents/' + folder.name.toString().toLowerCase().split(' ').join('-'),
            fontIcon: 'fal fa-' + (folder.icon ? folder.icon : 'folder')
          });
        });

        nav[0]._children = _.flatten([
          navDashboard, navNotifications, navOrders, navEstimates, temp, navTools
        ]);

        this.nav = nav;

        const documentFoldersResponsePagination = documentFoldersResponse.response.data.data.pagination;

        // if there's a next page then fetch documents on the next page too
        if (documentFoldersResponsePagination.next_page_url) {
          this.fetchDocumentFolders(documentFoldersResponsePagination.next_page_url);
        }

        return this.loading;
      });
    }
  },
  mounted () {
    this.$root.$on('toggle-sidebar', () => {
      const sidebarOpened = this.show === true || this.show === 'responsive'
      this.show = sidebarOpened ? false : 'responsive'
    })
    this.$root.$on('toggle-sidebar-mobile', () => {
      const sidebarClosed = this.show === 'responsive' || this.show === false
      this.show = sidebarClosed ? true : 'responsive'
    })
    if(this.$store.getters.isAdmin) {
      this.nav = admin_nav;
    } else {
      this.fetchDocumentFolders();
    }
  }
}
</script>
